import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Shield, Check } from 'lucide-react';
import { useFacilitateAuth } from '../../context/FacilitateAuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const FacilitateAcceptInvite = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useFacilitateAuth();
  const inviteToken = searchParams.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError('Passwords do not match'); return; }
    if (password.length < 6) { setError('Password must be at least 6 characters'); return; }
    setLoading(true); setError('');
    try {
      const res = await fetch(`${API_URL}/api/sessions/speakers/set-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ token: inviteToken, password }),
      });
      const data = await res.json();
      if (res.ok) {
        login(data.access_token, data.speaker);
        navigate('/facilitate');
      } else {
        setError(data.detail || 'Failed to set password');
      }
    } catch {
      setError('Network error');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#071B3A] flex items-center justify-center px-6">
      <Helmet><meta name="robots" content="noindex, nofollow, noarchive" /></Helmet>
      <div className="max-w-sm w-full">
        <div className="text-center mb-8">
          <Shield size={24} className="text-[#C99316] mx-auto mb-3" />
          <h1 className="font-serif text-2xl text-[#FAF8F3] font-light">Set Your Password</h1>
          <p className="text-[#FAF8F3]/30 text-sm mt-2">You've been invited to facilitate CFQ sessions</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Choose a password" required className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-[#FAF8F3] text-sm placeholder-white/20 focus:outline-none focus:border-[#C99316]/30" data-testid="invite-password-input" />
          <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="Confirm password" required className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-[#FAF8F3] text-sm placeholder-white/20 focus:outline-none focus:border-[#C99316]/30" data-testid="invite-confirm-input" />
          {error && <p className="text-red-400 text-sm">{error}</p>}
          <button type="submit" disabled={loading} className="w-full bg-[#C99316] text-[#071B3A] py-3 rounded-lg text-sm font-medium hover:bg-[#C99316]/90 disabled:opacity-50" data-testid="invite-set-password-btn">
            {loading ? 'Setting up...' : 'Set Password & Enter'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default FacilitateAcceptInvite;
